/**
 * "Is this hotspot coordinate unset?" — type-agnostic.
 *
 * The legacy PHP surface returned every column as a STRING, so the composer
 * tested `lat === "0"`. The /api surface returns NATIVE numbers, and `0 === "0"`
 * is false: every strict test silently inverted, reporting unpositioned
 * hotspots as positioned (the null-island class of bug this migration has hit
 * before). This helper accepts both, plus null/""/undefined for a row whose
 * coordinate was never written.
 */
export function isUnsetCoord(value) {
  if (value === null || value === undefined || value === "") {
    return true;
  }
  const n = Number(value);
  return !isNaN(n) && n === 0;
}

export default isUnsetCoord;
